<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Empresa o Filial</h5>
        </div>
        <emt-form ref="company-form" v-bind:resource="config.api + '/company/'" v-bind:items="itemsForm" v-on:register="reload" v-bind:updateData="update"></emt-form>
        <emt-grid ref="company-grid" v-bind:resource="config.api + '/company/'" v-bind:items="itemsGrid" v-bind:edit="editUrl" v-bind:deleteUrl="deleteUrl"></emt-grid>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'
import EmtLoading from '@/components/emt-loading'
import EmtTable from '@/components/emt-grid'

export default{
    name: 'emt-form-company',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Empresa o filial',
                    'placeholder': 'Ingrese nombre de empresa o filial',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }
            ],
            itemsGrid: [
                {
                    'name': 'name',
                    'label': 'Empresa o filial',
                    'ordering': true,
                    'filters': ['exact', {
                        'name': 'icontains',
                        'label': 'Puede contener'
                    }]
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'ordering': true
                }
            ],
            config: Config,
            update: false,
            editUrl: '/company/',
            deleteUrl: Config.api + '/company/'
        }
    },
    methods: {
        reload: function () {
            this.$refs['company-grid'].reload()
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
    },
    components: {
        'emt-form': EmtForm,
        'emt-loading': EmtLoading,
        'emt-grid': EmtTable
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-company.vue?753851a8